import axios from "axios";

export default async function fetchPoolStakeSetting() {
  const url = `${process.env.NEXT_PUBLIC_POOL_CDN}?q=${new Date().getTime()}`;
  let result = null;
  const res = await axios({
    method: "get",
    url: url,
  });
  if (res.status === 200) {
    result = res.data;
  }
  return result;
}
